import { setPositionX, setPositionY } from "../helpers";

function isMobile() {
	return (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i));
}

function isTouchDevice() {
	var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
	var mq = function (query) {
		return window.matchMedia(query).matches;
	}

	if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
		return true;
	}

	// include the 'heartz' as a way to have a non matching MQ to help terminate the join
	// https://git.io/vznFH
	var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
	return mq(query);
}

export class DrawingZoom {
	constructor(canvas) {
		this.canvas = canvas;
		this.zoom = 1;
		this.zoomMin = 0.1;
		this.zoomMax = 2.0;
		this._isCtrlDown = false;

		this.canvas.on({ "mouse:wheel": this._mouseWheelHandler.bind(this) });
		this.__c = this.canvas.getElement();
	}

	subscribe() {
		if (isTouchDevice() && isMobile()) {
			this.__keyDown = (e) => {
				if (e.keyCode === 17) this._isCtrlDown = true;
			};
			this.__keyUp = (e) => {
				if (e.keyCode === 17) this._isCtrlDown = false;
			};
			document.addEventListener('keydown', this.__keyDown);
			document.addEventListener('keyup', this.__keyUp);
			this.__subcribed = true;
		}
	}

	realeaseResources() {
		if (this.__subcribed) {
			document.removeEventListener('keydown', this.__keyDown);
			document.removeEventListener('keyup', this.__keyUp);
		}
	}

	_mouseWheelHandler(opt) {
		if (opt.e.ctrlKey === true || this._isCtrlDown === true) {
			const devider = opt.e.ctrlKey === true ? 400 : 4000;
			const delta = opt.e.deltaY;
			this.zoom = this.zoom - delta / devider;
			if (this.zoom > this.zoomMax) this.zoom = this.zoomMax;
			if (this.zoom < this.zoomMin) this.zoom = this.zoomMin;

			this.applyZoom();

			opt.e.preventDefault();
			opt.e.stopPropagation();
		}
	}

	setZoomToFitWindow() {
		this.zoom = this._getZoomRatioToFitWindow();
		this.applyZoom();
	}

	_getZoomRatioToFitWindow() {
		const origSize = this.canvas.initialSize;
		const wRatio = origSize.w / (window.innerWidth - (50 + 40)); //main + second toolbars
		const hRatio = origSize.h / (window.innerHeight - 60); // top toolbar
		const ratio = Math.max(wRatio, hRatio);
		return 1 / ratio;
	}

	_correctZoom(up) {
		this.zoom = up
			? Math.ceil(this.zoom * 10) / 10
			: Math.floor(this.zoom * 10) / 10;
	}

	zoomIn() {
		if (this.zoom < this.zoomMax) {
			this.zoom = Number((this.zoom + 0.1).toFixed(2));
			this._correctZoom(false);
			this.applyZoom();
		}
	}

	zoomOut() {
		if (this.zoom > this.zoomMin) {
			this.zoom = Number((this.zoom - 0.1).toFixed(2));
			this._correctZoom(true);
			this.applyZoom();
		}
	}

	applyZoom() {
		this.canvas.setZoom(this.zoom);

		const initialSize = this.canvas.initialSize;
		this.canvas.setWidth(initialSize.w * this.zoom);
		this.canvas.setHeight(initialSize.h * this.zoom);

		// needs while zooming out to keen the canvas on the screen
		setPositionX(this.canvas, 0);
		setPositionY(this.canvas, 0);

		if (this.zoom < this._getZoomRatioToFitWindow()) {
			this.__c.parentElement.style.marginTop = "10px";
			this.__c.parentElement.style.borderTop = "";
			this.__c.parentElement.style.borderBottom = "";
		} else {
			this.__c.parentElement.style.marginTop = "0px";
			this.__c.parentElement.style.borderTop = "none";
			this.__c.parentElement.style.borderBottom = "none";
		}

		if (typeof this.zoomChangeCallback === 'function') this.zoomChangeCallback();
	}

	get isMaxZoomReached() {
		return (this.zoom >= this.zoomMax);
	}

	get isMinZoomReached() {
		return (this.zoom <= this.zoomMin);
	}
}
